export function useContactUs() {
  function sendMessage(body) {
    return useRequest('/contacts', {
      method: 'post',
      body: {
        name: body.name,
        email: body.email,
        message: body.message,
        ['g-recaptcha-response']: body['g-recaptcha-response'],
      },
    });
  }

  return { sendMessage };
}
